import Arrow from 'assets/icons/arrow.svg';
import Logout from 'assets/icons/logout.svg';
import tcgLogo from 'assets/icons/tcg-logo.svg';
import { logOutUser } from 'helpers/axios';
import { getBackButtonLabel, navigateToPortal } from 'helpers/navigation';
import { useDeviceType } from 'hooks/useDeviceType';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from 'store/store';
import { setUser } from 'store/user/actions';
import styled from 'styled-components';

import { DeviceType } from 'constants/device';
import { USER_ROLE } from 'constants/user';

const NavigationWrapper = styled.div`
  box-shadow: 0 10px 13px rgba(90, 1, 10, 0.03);
  height: 80px;
  border-bottom: 1px solid ${props => props.theme.colors.grey.main};
  background-color: ${props => props.theme.colors.white.main};
  font-family: ZonaPro;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-left: 8%;
  padding-right: 8%;
  position: sticky;
  top: 0;
  z-index: ${props => props.theme.zIndex.appBar};
`;

const Button = styled.div`
  font-size: 12px;
  color: ${props => props.theme.colors.lightBrown[100]};
  display: flex;
  font-weight: 600;
  margin-left: 40px;

  &:hover {
    cursor: pointer;
  }
`;

const LogoWrapper = styled.div`
  ${props => props.theme.typography.mobileBodyXS};
  align-items: center;
  color: ${props => props.theme.colors.darkGrey[60]};
  display: flex;
  letter-spacing: 1px;
`;

const Logo = styled.img`
  cursor: pointer;
  width: 91px;
  height: 32px;
  margin-right: 12px;
`;

const ArrowIcon = styled.img`
  margin-left: 8px;
`;

const Controls = styled.div`
  display: flex;
  flex: 1;
  justify-content: end;
  white-space: nowrap;
`;

interface Props {
  isUserRegistered: boolean;
}

export const NavigationBar: React.FC<Props> = ({ isUserRegistered }) => {
  const { user } = useSelector((state: RootState) => state.user);
  const [buttonLabel, setButtonLabel] = useState<string>('Back');
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const navigate = useNavigate();
  const isDesktopDevice = useDeviceType() === DeviceType.DESKTOP;
  const dispatch = useDispatch();

  useEffect(() => {
    setButtonLabel(getBackButtonLabel(user?.role as USER_ROLE));
    setIsAdmin(user?.role === USER_ROLE.ADMIN);
  }, [user?.role]);

  const logOut = async () => {
    dispatch(setUser(undefined));
    await logOutUser();
    navigateToPortal(user?.role as USER_ROLE);
  };

  return (
    <NavigationWrapper>
      <LogoWrapper>
        <Logo src={tcgLogo} onClick={() => navigate('/')} />
        {isDesktopDevice && 'COMMUNITY'}
      </LogoWrapper>
      {isUserRegistered && (
        <Controls>
          {!isAdmin ? (
            <Button onClick={() => navigateToPortal(user?.role as USER_ROLE)}>
              {buttonLabel} <ArrowIcon src={Arrow} alt="" />
            </Button>
          ) : (
            <Button onClick={logOut}>
              Logout <ArrowIcon src={Logout} alt="" />
            </Button>
          )}
        </Controls>
      )}
    </NavigationWrapper>
  );
};
